import { Box, type SpaceProps } from '@chakra-ui/react'
import { css } from '@emotion/react'

export default function MessageBox({
  text,
  bgColor = 'bg.info',
  hidePointer = false,
  ...props
}: { text: string; bgColor?: string; hidePointer?: boolean } & SpaceProps): JSX.Element {
  return (
    <Box
      bg={bgColor}
      borderRadius="md"
      position="relative"
      px={5}
      py={3}
      css={
        !hidePointer
          ? css`
        &:after {
          content: '';
          position: absolute;
          top: 0;
          left: 24px;
          width: 0;
          height: 0;
          border: 12px solid transparent;
          border-bottom-color: ${bgColor};
          border-top: 0;
          margin-left: -12px;
          margin-top: -12px;
        }
      `
          : undefined
      }
      {...props}
    >
      {text}
    </Box>
  )
}
